import { ListApiResponse } from '@ianesthesie-kit/services';
import { Notification, NotificationType } from './notification.model';
import { MedicalResponse } from '@/modules/surgicalEvent/baseMedical.service';
import axios from 'axios';
import { toKebabQuery } from '@/util';
import omit from 'lodash/fp/omit';
import { PatientId } from '@/modules/surgicalEvent';

export type NotificationPayload = Pick<
  Notification,
  'message' | 'type' | 'toUserId'
>;

export type NotificationPerUserParams = {
  page?: number;
  pageSize?: number;
  notificationType?: NotificationType;
};

// TODO rename all module to Messaging service etc

export class NotificationService {
  private static readonly INSTANCE: NotificationService =
    new NotificationService();

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static getInstance(): NotificationService {
    return this.INSTANCE;
  }

  public fetchMessages({
    patientId,
    ...params
  }: NotificationPerUserParams & PatientId): Promise<
    MedicalResponse<Notification, true>
  > {
    if (!patientId) {
      throw new Error('Patient id cannot be undefined');
    }

    const normalizedParams = {
      ...omit(['notificationType'], params),
      type: params.notificationType
    };

    return axios
      .get<ListApiResponse<Notification>>(
        `/patient/${patientId}/notification${toKebabQuery(normalizedParams)}`
      )
      .then((resp) => ({
        data: resp.data.data
      }));
  }

  public send(
    payload: NotificationPayload
  ): Promise<MedicalResponse<void, false>> {
    if (!payload) {
      throw new Error('empty payload'); // TODO proper error medicalResponse
    }

    const { toUserId, ...postPayload } = payload;
    return axios
      .post(`/patient/${toUserId}/notification/sync`, postPayload)
      .then(() => ({
        data: {} as any
      }));
  }

  public retryFailed(
    notification: Notification
  ): Promise<MedicalResponse<void, false>> {
    if (!notification) {
      throw new Error('Notification is undefined');
    }

    if (notification.status !== 'FAILED') {
      throw new Error('Notification is not failed');
    }

    const { toUserId, id } = notification;

    return axios
      .post(`/patient/${toUserId}/notification/${id}/retry`)
      .then(() => ({
        data: {} as any
      }));
  }
}
